module.exports = __webpack_public_path__ + "img/man-emition-in-person.85eac56.png";